import type { ExperimentKey, FinanceExperimentDef } from '../types';
import { experiment as compoundInterestExperiment } from './compound-interest';
import { experiment as powerOfTimeExperiment } from './power-of-time';
import { experiment as savingsGoalExperiment } from './savings-goal';
import { experiment as borrowingCostExperiment } from './borrowing-cost';
import { experiment as inflationExperiment } from './inflation';
import { experiment as feesDragExperiment } from './fees-drag';

// ============================================================================
// Experiment Registry — all six experiments registered. Record (not Partial)
// enforces complete coverage; the index.test.ts contract guards drift.
// ============================================================================

export const EXPERIMENTS: Record<ExperimentKey, FinanceExperimentDef> = {
  'compound-interest': compoundInterestExperiment,
  'power-of-time': powerOfTimeExperiment,
  'savings-goal': savingsGoalExperiment,
  'borrowing-cost': borrowingCostExperiment,
  inflation: inflationExperiment,
  'fees-drag': feesDragExperiment,
};

/**
 * Curriculum order: time-value foundations → growth → debt → erosion.
 */
export const EXPERIMENT_ORDER: ExperimentKey[] = [
  'compound-interest',
  'power-of-time',
  'savings-goal',
  'borrowing-cost',
  'inflation',
  'fees-drag',
];
